import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type SendMonthlyReportNotificationsRequest = {
  toList: string;
  fileName: string;
};

export type SendMonthlyReportNotificationsResponse = {
  sent: boolean;
};

export const SendMonthlyReportNotifications = async (request: SendMonthlyReportNotificationsRequest) => {
  const response = await executeApiRequest(() => axios.post<SendMonthlyReportNotificationsResponse>("/monthlyReports/sendEmails", request), false);

  return response?.data.sent;
};
